import { render, staticRenderFns } from "./fix-compass.vue?vue&type=template&id=219a1458&scoped=true"
import script from "./fix-compass.vue?vue&type=script&lang=js"
export * from "./fix-compass.vue?vue&type=script&lang=js"
import style0 from "./fix-compass.vue?vue&type=style&index=0&id=219a1458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219a1458",
  null
  
)

export default component.exports